// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"99":"bc2dcd7b","598":"d267eb28"}[chunkId] + ".js";
};